import React, { Component } from 'react';

import axios from 'axios';
import CollectionCard from './CollectionCard';
import NewCollectionCard from './NewCollectionCard';
import { Animated } from 'react-animated-css';

// Display account collections and a button to create a new one
class CollectionGallery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collectionCards: new Array()
    };

    this.loadCollectionCards = this.loadCollectionCards.bind(this);
  }

  componentDidMount() {
    this.loadCollectionCards();
  }

  // Load collection cards
  async loadCollectionCards() {

    // Array of options in address select
    var collectionCards = new Array();

    collectionCards[0] = <NewCollectionCard
      changeVisibilities={this.props.changeVisibilities}
      key="0" />;

    // Fetch existing collections
    var collections = undefined;
    if (this.props.accountAddress != '') { // Call API only if we have a selected account
      collections = await axios.get(process.env.REACT_APP_API_URL + "api/v1/collections?sortBy=creationTimestamp&orderBy=desc&owner=" + this.props.accountAddress)
        .then(function (response) {
          return response.data.data;
        })
        .catch(function (error) {
          console.error("Error while fetching collections")
          return undefined;
        });
    }

    // Check if collections found
    if (typeof collections !== 'undefined' && Object.keys(collections).length !== 0) {
      for (var index in collections) {
        collectionCards[parseInt(index) + 1] =
          <CollectionCard
            openMintNftForCollection={this.props.openMintNftForCollection}
            changeVisibilities={this.props.changeVisibilities}
            key={index + 1}
            collection={collections[index]} />;
      }

    }
    this.setState({
      collectionCards: collectionCards
    });
  }

  render() {
    return (
      <Animated animationIn="fadeIn" animationInDuration={300} isVisible={this.props.display}>
        <div className={`card ${!this.props.display ? ' d-none' : ''}`} id="collection-gallery">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="alc-staff-inner post__meta-block posts__item--card posts__item">
                  <header className="alc-staff__header">
                    <h1 className="page-heading__title">
                      <span className="alc-staff__header-last-name">
                        Collection Gallery
                    </span>
                    </h1>
                    <span className="alc-staff__header-role">
                      <h5 className="alc-staff__header-role-item">
                        Create a collection, mint, or send your nft
                    </h5>
                    </span>
                  </header>
                  <button className="btn btn-primary" onClick={this.props.openNftGallery}>Send your NFTs</button>
                </div>
              </div>
            </div>
          </div>

          <div className="card__content posts posts--cards post-grid row">
            {this.state.collectionCards.map((card, i) => { return (card) })}
          </div>
        </div>
      </Animated>
    )
  }
}

export default CollectionGallery;